/**
 * CMS API disabled — this marketing site is fully static (no Laravel CMS).
 * Kept as a thin config so older imports still resolve.
 */

export function normalizeSiteDomain(value) {
  return String(value ?? '')
    .trim()
    .toLowerCase()
    .replace(/^https?:\/\//, '')
    .replace(/:\d+$/, '')
    .split('/')[0]
}

/** Empty = no remote CMS. */
export const CMS_API_BASE = ''

export const CMS_SITE_DOMAIN = normalizeSiteDomain(
  process.env.NEXT_PUBLIC_SITE_DOMAIN || 'airestro360.com',
)
